<template>
  <div class="upload-thumbnail-wrap">
    <h3>Set Fair Misc</h3>
    <select v-model="selectedOption">
      <option :value="''" selected disabled>Select:</option>
      <option v-for="option in options" :value="option" :key="option.type">{{transformOptionType(option.type)}}</option>
    </select>
    <div class="image-inputs-wrap" v-if="selectedOption.requiresFileUpload && selectedOption.type !== undefined">
      <div class="image-wrap" v-show="selectedOption.link">
        <img :src="'/' + selectedOption.link">
      </div>
      <div class="input-wrap">
        <label for="file">{{selectedOption.isHTML ? 'Browse HTML' : 'Browse'}}</label>
        <span v-if="file" class="span-file">{{file.name}}</span>
        <input type="file" id="file" @change="getFile" ref="file">
      </div>
    </div>

    <div class="input-wrap" v-if="!selectedOption.requiresFileUpload && selectedOption.type !== undefined">
      <input type="text" :placeholder="isDateInput? 'YYYY-MM-DD HH:MM:SS' : null" v-model.trim="textValue" v-if="selectedOption.type !== 'adminvalidation'">
      <input type="checkbox" v-else v-model="adminValidation">
    </div>

    <div class="buttons" v-if="selectedOption.type">
      <button @click="uploadHandler">Upload</button>
    </div>
  </div>
</template>

<script>
import AdminMixin from '@/views/admin-pages/adminMixin.js'
import options from '@/components/admin/fair-config/options.js'
import api from '@/api'
export default {
  mixins: [
    AdminMixin
  ],
  data () {
    return {
      options,
      selectedOption: '',
      textValue: '',
      file: '',
      adminValidation: false
    }
  },
  computed: {
    isDateInput () {
      if (this.selectedOption.type === 'start_date' || this.selectedOption.type === 'end_date') {
        return true;
      } else {
        return false;
      }
    }
  },
  watch: {
    selectedOption: {
      deep: true,
      handler () {
        this.resetFile();
      }
    }
  },
  methods: {
    async uploadHandler () {
      if (this.selectedOption.requiresFileUpload) {
        await this.uploadMedia();
      } else {
        await this.uploadText();
      }
    },
    async uploadText () {
      let params = {
        image_type: this.selectedOption.type
      };
      if (this.selectedOption.type !== 'adminvalidation') {
        if (this.textValueHasError()) {
          return;
        }
        params.data = this.textValue;
      } else {
        params.data = this.adminValidation ? 1 : 0; 
      }

      await this.upload(params);
    },
    textValueHasError () {
      if (this.textValue.length === 0) {
        this.handleError(new Error("Value can't be empty."))
        return true;
      }
      if (this.textValue.length > 250) {
        this.handleError(new Error("Value too long."))
        return true;
      }
      if (this.selectedOption.type === 'start_date' || this.selectedOption.type === 'end_date') {
        const timestampRegEx = /[0-9]{4}-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1]) (2[0-3]|[01][0-9]):[0-5][0-9]:[0-5][0-9]/;
        if (!timestampRegEx.test(this.textValue)) {
          this.handleError(new Error('Date format is invalid. Valid format is "YYYY-MM-DD HH:MM:SS"'))
          return true;
        }
      }

      return false;
    },
    async upload (params) {
      let apiObj = {
        api: api.setFairMedia,
        params,
        onError: () => this.stopLoading()
      }
      this.startLoading();
        const data = await this.apiCall(apiObj);
        if (data) {
          this.showSuccessMessage('Uploaded.');
          this.resetFile();
        }
      this.stopLoading();
    },
    async uploadMedia () {
      if (!this.file) {
        this.handleError(new Error('No file selected.'))
        return;
      }
      let formData = new FormData();
      formData.append('image_type', this.selectedOption.type);
      formData.append('data', this.file);

      this.upload(formData);
    },
    resetFile () {
      if (this.file) {
        this.file = '';
        this.$refs.file.value = '';
      }
    },
    getFile (e) {
      this.file = e.target.files[0];
    },
    transformOptionType (type) {
      let capitalizedType = type.charAt(0).toUpperCase() + type.slice(1);
      return capitalizedType.replaceAll('_', ' ');
    }
  },
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
.upload-thumbnail-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px 0;
  width: 60%;
  padding: 0 20px 20px 20px;
}
.buttons {
  margin: 10px 0;
}
button, .input-wrap label {
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  white-space: nowrap;
  outline: none;
  border: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
}
.image-inputs-wrap {
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  margin: 5px 0;
  width: 70%;
}
.input-wrap {
  display: flex;
  justify-content: center;
  width: 50%;
}
.input-wrap label {
  background: gray;
  font-size: 0.7em;
}
.input-wrap input {
  margin: 10px 0;
}
input[type=file] {
  display: none;
}
.span-file {
  font-size: 0.7em;
}
.image-wrap {
  max-width: 50%;
}
</style>